import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TableBase } from '../../../shared/components/table/table-base';
import { ActionEvent, CellClickEvent, ColumnTypes, SortEvent } from '../../../shared/components/table/table.component';
import { AppscriptsSmsFilter } from '../../../shared/models/appscripts-sms.model';
import { AppscriptsSmsRequestParams, AppscriptsSmsService } from '../../../shared/services/appscripts-sms.service';
import { AppscriptsUserRequestParams, AppscriptsUserService } from '../../../shared/services/appscripts-user.service';
import { BrowserUtils } from '../../../shared/services/browser-utils';
import { ModalService } from '../../../shared/services/modal.service';
import { NotificationService } from '../../../shared/services/notification.service';

@Component({
  standalone: false,
  selector: 'app-appscripts-mo-sms-table',
  templateUrl: 'app-appscripts-mo-sms-table.html',
})
export class AppscriptsMoSmsTableComponent extends TableBase implements OnInit {
  @Output() actions = new EventEmitter();

  filter: AppscriptsSmsFilter;
  requestParams = new AppscriptsSmsRequestParams();
  storageContextName = 'appscripts-mo-sms-table';

  loading = true;

  constructor(
    public notificationService: NotificationService,
    public service: AppscriptsSmsService,
    public serviceUser: AppscriptsUserService,
    public router: Router,
    public modal: ModalService,
    private datePipe: DatePipe
  ) {
    super();
  }

  ngOnInit() {
    this.setColumns(
      this.createColumns([
        { title: 'ID', prop: 'moId', sort: true },
        { title: 'Origination phone', prop: 'phoneNumber', cellClassName: 'editable' },
        { title: 'Destination phone', prop: 'destination' },
        { title: 'Text', prop: 'text', type: ColumnTypes.HTML, format: this.formatText },
        { title: 'DLR received', prop: 'receivedAt', format: row => this.formatDate(row.receivedAt), sort: true },
        { title: 'Created', prop: 'createdAt', format: row => this.formatDate(row.createdAt), sort: true },
      ])
    );
  }

  onPageChange(event) {
    this.page = event;
    this.update();
  }

  onChangeSize(size: number) {
    super.onChangeSize(size);
    this.update();
  }

  update() {
    this.requestParams.size = this.currentSize;
    this.requestParams.page = this.page - 1;
    this.requestParams.resetSort();

    for (const sort of this.order) {
      this.requestParams.setSort(sort.prop, sort.direction);
    }
    if (this.filter) {
      this.requestParams.filter = this.filter;
    }
    this.loading = true;
    this.service.allMo(this.requestParams).subscribe(
      data => {
        this.setData(this.createRows(data.content), data.totalElements > 5000 ? 5000 : data.totalElements);
        this.loading = false;
      },
      () => (this.loading = false)
    );
  }

  onAction(event: ActionEvent) {
    this.actions.emit(event);
  }

  onSort(order: SortEvent[]) {
    this.onChangeOrder(order);
    this.order = order;
    this.update();
  }

  formatDate(date) {
    if (!date) {
      return 'N/A';
    }
    return this.datePipe.transform(new Date(date), 'medium');
  }

  formatText(row) {
    if (!row.text) {
      return '';
    }
    if (!row.telqId) {
      return BrowserUtils.escapeHtml(row.text);
    }
    return BrowserUtils.escapeHtml(row.text).replace(row.telqId, `<span class="text-success">${row.telqId}</span>`);
  }

  onCellClick(event: CellClickEvent) {
    if (event.column.prop === 'phoneNumber') {
      this.loading = true;
      const requestParams = new AppscriptsUserRequestParams();
      requestParams.size = 1;
      this.router.navigate(['appscripts/numbers'], { queryParams: { phonenumber: event.row.data.phoneNumber } }).then();
    }
  }
}
